module.exports = __webpack_public_path__ + "img/antes_despues_226.5aa25b82.png";